import React, { Component } from "react";
import {
	Row,
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Label,
} from "reactstrap";
import IntlMessages from "../../helpers/IntlMessages";
import { Colxx, Separator } from "../../components/common/CustomBootstrap";
import PrintBatchUIDContent from "./PrintBatchUIDContent";
import ReactToPrint from 'react-to-print';

export default class PrintBatchUIDModal extends Component{
	constructor(props) {
		super(props);
	}

	render() {	
		return (	  
			<Modal
			  isOpen={this.props.modalOpen}
			  toggle={this.props.toggleModal}
			  size="md"
			>
				<ModalHeader toggle={this.props.toggleModal}>
					Print Label
				</ModalHeader>
			 
				<ModalBody>
					<Row>
						<Colxx lg="12">
							<PrintBatchUIDContent
								ref={el => (this.componentRef = el)} 
								crude_oil={this.props.crude_oil}
								record_batch_uid={this.props.record_batch_uid}
							/>
						</Colxx>					
					</Row>
				</ModalBody>
				<ModalFooter className="justify-content-start">
					<ReactToPrint
						trigger={() => <Button color="primary" ><IntlMessages id="customer.print" /></Button>}
						content={() => this.componentRef}
						copyStyles={true}
						pageStyle={""}
					/>
					<Button color="secondary" outline onClick={this.props.toggleModal}>
						<IntlMessages id="customer.cancel" />
					</Button>{" "}
				</ModalFooter>
			</Modal>
	  );
  }
};
